import { render, staticRenderFns } from "./PlayerRating.vue?vue&type=template&id=18a5ab5b&scoped=true&"
import script from "./PlayerRating.vue?vue&type=script&lang=js&"
export * from "./PlayerRating.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRating.vue?vue&type=style&index=0&id=18a5ab5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a5ab5b",
  null
  
)

export default component.exports